import React from 'react';
// import Slick from 'react-slick';
import smoothScroll from 'smoothscroll';
import SortSelect from 'components_v2/common/SortSelect';
import Link from 'components/Link';
import s from './BudgetRupeeWrapper.scss';
import RenderChartDonut from './RenderChartsDonut';
import SwitchTabs from '../../../components/ElectionV2/common/SwitchTabs/SwitchTabs';
import PopupPortal from '../../mobile/PopupPortal/PopupPortal';

class BudgetRupeeWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.tabs = [
      { name: 'Income', index: 1, key: 'income' },
      { name: 'Expenditure', index: 2, key: 'expenditure' },
    ];
    try {
      this.sources = this.props.sectionData.items.years
        ? Object.keys(this.props?.sectionData?.items?.years || {}).map(a => ({
            name: a,
          }))
        : [];
    } catch (error) {
      this.sources = [];
    }
    this.state = {
      activeTab: this.tabs[0],
      selectedOption:
        this.sources && Array.isArray(this.sources) && this.sources.length > 0
          ? this.sources[0]
          : {},
      selectedOption2:
        this.sources && Array.isArray(this.sources) && this.sources.length > 0
          ? this.sources[0]
          : {},
    };
  }

  getColorClass = change => {
    if (change > 0) return s.green;
    if (change < 0) return s.red;
    return s.defaultColor; // Assuming you have a default color defined in your CSS
  };

  getChangeText = change => {
    if (change !== 0)
      return change > 0
        ? `+ ₹${change.toLocaleString()}`
        : `- ₹${Math.abs(change).toLocaleString()}`;
    return 'No Change';
  };

  tabHandler = tab => {
    this.setState({ activeTab: tab });
    if (window?._dfpObj?.tabChanged) {
      window._dfpObj.tabChanged(tab, 'pichartAD');
    }
    if (this.props.isWapView) {
      smoothScroll(0, 1000);
    }
  };

  handleOnChange = value => {
    this.setState({
      selectedOption: value,
    });
  };

  handleOnChange2 = value => {
    this.setState({
      selectedOption2: value,
    });
  };

  getAnotherYearData = (years, item) => {
    const source2Data =
      years[this.state.selectedOption2.name]?.[this.state.activeTab.key];
    return source2Data &&
      Array.isArray(source2Data) &&
      Array.isArray(source2Data.filter(item2 => item2.name === item.name)) &&
      source2Data.filter(item2 => item2.name === item.name).length > 0 &&
      source2Data.filter(item2 => item2.name === item.name)[0]?.val
      ? source2Data.filter(item2 => item2.name === item.name)[0].val
      : 0;
  };

  getTotalDataForYear = (years, name, key) => {
    const sourceData = years?.[name]?.[key];
    return sourceData && Array.isArray(sourceData)
      ? sourceData.reduce((acc, val) => {
          acc += val?.val || 0;
          return acc;
        }, 0)
      : 0;
  };

  render() {
    const { years = {}, kp = '' } = this.props.sectionData?.items || {};
    return (
      <div className={s.budgetRupeeWrapper}>
        <meta name="format-detection" content="telephone=no" />
        <div className={`${s.flex} ${s.topTabWrap}`}>
          {!this.props.isWapView && (
            <div className={s.stWrap}>
              <SwitchTabs
                tabs={this.tabs}
                tabHandler={this.tabHandler}
                isToggle
              />
            </div>
          )}
          <div className={s.ssWrap}>
            <SortSelect
              selected
              options={this.sources}
              onSelect={this.handleOnChange}
              selectedOption={this.state.selectedOption}
            />
          </div>
        </div>
        <RenderChartDonut
          isWapView={this.props.isWapView}
          tab={this.state.activeTab.index}
          source={this.state.selectedOption.name}
          data={
            years[this.state.selectedOption.name]?.[this.state.activeTab.key]
          }
        />
        <div className={s.styleBorder} />
        <p className={s.linerText}>Compare:</p>
        <div className={`${s.flex} ${s.vsWrap}`}>
          <div className={s.ssWrap}>
            <SortSelect
              selected
              options={this.sources}
              onSelect={this.handleOnChange}
              selectedOption={this.state.selectedOption}
            />
          </div>
          <div className={s.vsBox}>vs</div>
          <div className={s.ssWrap}>
            <SortSelect
              active={
                this.state.selectedOption.name !==
                this.state.selectedOption2.name
              }
              options={this.sources}
              onSelect={this.handleOnChange2}
              selectedOption={this.state.selectedOption2}
            />
          </div>
        </div>
        <p className={s.linerText}>
          The following table shows India’s budget over the years:
        </p>
        <div className={s.tableWrap}>
          <div className={`${s.flex} ${s.row} ${s.darkRow} ${s.headRow}`}>
            <div className={`${s.col} ${s.firstCol}`}>Category</div>
            <div className={s.col}>
              <div>
                {this.state.activeTab.name}{' '}
                {this.state.selectedOption.name !==
                this.state.selectedOption2.name
                  ? 'Change '
                  : ''}
                <span className={s.incr}>(in Cr.)</span>
              </div>
            </div>
          </div>
          <div className={s.tableCenter}>
            {years[this.state.selectedOption.name]?.[
              this.state.activeTab.key
            ] &&
              Array.isArray(
                years[this.state.selectedOption.name]?.[
                  this.state.activeTab.key
                ],
              ) &&
              years[this.state.selectedOption.name]?.[
                this.state.activeTab.key
              ]?.map(item => (
                <div className={`${s.flex} ${s.row}`}>
                  <div className={`${s.col} ${s.firstCol}`}>
                    <span className={s.mainText}>{item.name}</span>
                    {this.state.selectedOption.name !==
                      this.state.selectedOption2.name && (
                      <>
                        <div className={s.extraInfo}>
                          <span>{this.state.selectedOption.name}:</span> ₹{item.val.toLocaleString()}
                        </div>
                        <div className={s.extraInfo}>
                          <span>{this.state.selectedOption2.name}:</span> ₹{this.getAnotherYearData(
                            years,
                            item,
                          ).toLocaleString()}
                        </div>
                      </>
                    )}
                  </div>
                  <div className={s.col}>
                    {this.state.selectedOption.name ===
                      this.state.selectedOption2.name && (
                      <span className={s.mainText}>
                        ₹{item.val.toLocaleString()}
                      </span>
                    )}
                    {this.state.selectedOption.name !==
                      this.state.selectedOption2.name && (
                      <div
                        className={`${s.changedData} ${this.getColorClass(
                          item.val - this.getAnotherYearData(years, item),
                        )}`}
                      >
                        {this.getChangeText(
                          item.val - this.getAnotherYearData(years, item),
                        )}
                        <div className={s.changedPercent}>
                          {item.val - this.getAnotherYearData(years, item) !==
                            0 &&
                            `(${(
                              100 *
                              (item.val -
                                this.getAnotherYearData(years, item)) /
                              item.val
                            ).toFixed(2)}%)`}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </div>
          <div className={`${s.flex} ${s.row} ${s.darkRow}`}>
            <div className={`${s.col} ${s.firstCol}`}>
              Total {this.state.activeTab.name}
              {this.state.selectedOption.name !==
                this.state.selectedOption2.name && (
                <>
                  <div className={s.extraInfo}>
                    {this.state.selectedOption.name}: ₹{this.getTotalDataForYear(
                      years,
                      this.state.selectedOption.name,
                      this.state.activeTab.key,
                    ).toLocaleString()}
                  </div>
                  <div className={s.extraInfo}>
                    {this.state.selectedOption2.name}: ₹{this.getTotalDataForYear(
                      years,
                      this.state.selectedOption2.name,
                      this.state.activeTab.key,
                    ).toLocaleString()}
                  </div>
                </>
              )}
            </div>
            <div className={s.col}>
              {this.state.selectedOption.name !==
              this.state.selectedOption2.name
                ? this.getChangeText(
                    this.getTotalDataForYear(
                      years,
                      this.state.selectedOption.name,
                      this.state.activeTab.key,
                    ) -
                      this.getTotalDataForYear(
                        years,
                        this.state.selectedOption2.name,
                        this.state.activeTab.key,
                      ),
                  )
                : `₹${this.getTotalDataForYear(
                    years,
                    this.state.selectedOption.name,
                    this.state.activeTab.key,
                  ).toLocaleString()}`}
            </div>
          </div>
        </div>
        {/* table */}
        <p className={s.otherBtmInfoText}>Knowledge Partner: {kp}</p>
        <p className={s.otherBtmInfoText}>
          Source:{' '}
          <Link to="https://www.indiabudget.gov.in/doc/Budget_at_Glance/bag6.pdf">
            Expenditure, Union Budget Documents
          </Link>{' '}
          |{' '}
          <Link to="https://www.indiabudget.gov.in/doc/Budget_at_Glance/bag5.pdf">
            Receipts, Union Budget Documents
          </Link>
        </p>
        <div className={s.otherBtmInfoWrap}>
          <span className={s.otherBtmInfoText}>Note:</span>
          {years?.[this.state.selectedOption.name]?.notes &&
            Array.isArray(years[this.state.selectedOption.name]?.notes) &&
            years[this.state.selectedOption.name]?.notes.length > 0 &&
            years[this.state.selectedOption.name]?.notes.map(note => (
              <p className={s.otherBtmInfoText}>{note}</p>
            ))}
        </div>
        {typeof window !== 'undefined' &&
          this.props.isWapView &&
          !this.props.isAppView && (
            <PopupPortal wrapper=".sticky-bottom-from-element" usePopupPortal>
              <SwitchTabs
                tabs={this.tabs}
                tabHandler={this.tabHandler}
                isToggle
              />
            </PopupPortal>
          )}
        {this.props.isWapView &&
          this.props.isAppView && (
            <div
              className={`${s.appviewSticky} ${
                !this.props.isPrime ? s.appviewStickyPrime : ''
              }`}
            >
              <SwitchTabs
                tabs={this.tabs}
                tabHandler={this.tabHandler}
                isToggle
              />
            </div>
          )}
      </div>
    );
  }
}

export default BudgetRupeeWrapper;
